import "@/Styles/ButtonCarousel.css";
import Skeleton from "react-loading-skeleton";
import useWindowsSize from "@/Hooks/useWindowsSize";
//import type { SubCategories } from "@/Models/MSubCategories/SubCategories";
import {
  HomeCarouselButton,
  LayoutCarousel,
  LinksBtnComponents,
} from "@/Components/Index";
import { Link, useParams } from "react-router-dom";
import {
  ReplaceCharacter,
  ReplaceCharacterRest,
} from "@/Utils/RemplaceCharacter";
import { useSubCategory } from "@/Service/Api/ApiPLP/Plp";

type paramsUrl = {
  cteg?: string;
  subcateg?: string;
};

export const CaruselButton = (): JSX.Element => {
  //obtenemos los parametros de la url
  const { cteg, subcateg } = useParams<paramsUrl>();
  //obtenemos el ancho de la pantalla
  const { width } = useWindowsSize();
  //obtenemos la lista de las sub-categorias
  const { listSubCategory, isLoadingCategory } = useSubCategory(
    cteg!,
    "electronica"
  );

  //****** End Remplazar dato o simbolo o algo *********\\
  const classFlex = "d-flex justify-content-center";

  const newViewBtn = () => {
    return (
      <>
        {isLoadingCategory && listSubCategory.length == 0 ? (
          <div className="p-1">
            <Skeleton className="w-100 p-5" />
          </div>
        ) : (
          <HomeCarouselButton>
            <div className="d-flex p-2">
              <div className={`${classFlex}`}>
                {listSubCategory.map((x, index) => (
                  <Link
                    to={`/Electrónica/${cteg}/${ReplaceCharacterRest(x.names)}`}
                    className={`ps-btn rounded-pill shadow button-border-MX develop___ColorText carouselHome h4 ${
                      x.names === ReplaceCharacter(subcateg!)
                        ? "btn-click-mx text-white"
                        : "bg-transparent"
                    } ml-4`}
                    key={index}>
                    <span className="d-flex justify-content-center align-items-center owl-nav">
                      {x.names}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </HomeCarouselButton>
        )}
      </>
    );
  };

  return width <= 1202 ? (
    <div className="ps_shopping__header_develop bg-white">{newViewBtn()}</div>
  ) : (
    <div className="w-100 d-flex justify-content-center align-items-center">
      {newViewBtn()}
    </div>
  );
};
